<template>
    <div class="m-5" style="background-color: #181a1b; color: white; border-radius: 10px;">
        <div class="d-flex flex-column p-3">
            <div class="row p-3">
                <h3>Invite User</h3>
            </div>
            <div class="row">
                <div class="col p-3">
                    E-Mail
                </div>
                <div class="col">
                    <input
                        type="text"
                        id="email"
                        v-model="email"
                        required
                    />
                </div>
            </div>
            <div class="row">
                <div class="col"></div>
                <div class="col p-3">
                    <button type="submit" class="submit-button" @click="sendUserInvite">Invite</button>
                </div>
            </div>
            <div class="row p-5">
            <table class="dark-table">
                <tbody>
                    <tr>
                        <th>E-Mail</th>
                        <th>Invite Code</th>
                        <th>Invite Date</th>
                        <th>Status</th>
                    </tr>
                    <tr v-for="invite in userInvites">
                        <td>{{ invite.inviteeEmail }}</td>
                        <td>{{ invite.inviteCode }}</td>
                        <td>{{ invite.inviteDateTime }}</td>
                        <td>
                            <span v-if="invite.active">Active</span>
                            <span v-else>Reedemed</span>
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>
        </div>
    </div>
    <DialogModal :error-message="dialogModalMessage" 
               :error-title="dialogModalTitle" 
               :info-class="dialogInfoClass"
               ref="dialogModal" />
</template>
<script>
import { getCookie } from '@/utils/cookies/cookieUtils';
import { endpoint } from '@/utils/endpoint/endpointUtils';
import DialogModal from '@/components/DialogModal.vue';
export default {
    components: {
        DialogModal
    },
    data() {
        return {
            email: null,
            userInvites: null,
            dialogModalMessage: '',
            dialogModalTitle: '',
            dialogInfoClass: 'alert alert-warning'

        }
    },
    async mounted() {
        await this.fetchUserInvites()
    },
    methods: {
        async fetchUserInvites() {
            try {
                const userid = getCookie('userid');
                const token = getCookie('token');

                const response = await fetch(endpoint + '/api/User/GetInvites/' + userid, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json',
                }});

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                } else {
                    const data = await response.json();
                    console.log(data);
                    this.userInvites = data.invites;
                }
            } catch(exception) { 
                console.log(exception); 
                //deleteAllCookies();
            }
        },
        async sendUserInvite() {
            const userid = getCookie('userid');
            const token = getCookie('token');

            const body = {
                'userId' : userid,
                'email' : this.email
            };
            try {
                const response = await fetch(endpoint + '/api/User/InviteUser', {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + token,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(body),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                console.log(data);
                if (data.message === 'Success') {
                    this.dialogModalMessage = "User Invite Sent Successfully";
                    this.dialogModalTitle = "Invite";
                } else {
                    this.dialogModalMessage = "There was an issue sending invite.";
                    this.dialogModalTitle = "Invite";
                }
            } catch(exception) {
                this.dialogModalMessage = exception;
                this.dialogModalTitle = "Exception occured";
            }

            // reset email field
            this.email='';
            
            this.$refs.dialogModal.openModal();
            await this.fetchUserInvites();
        }
    }
}
</script>
<style scoped>
.center-align {
    padding-top: 10px;
}
</style>